import { Checkbox, Input, Segmented, Select, Table, Tag, Popconfirm, Button, DatePicker } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
	countExpenseForm,
	loadAllExpenseForm,
	loadExpenseFormByStatus,
	DeleteExpense,
	updateExpenseForm
} from "../../redux/rtk/features/expense/expenseSlice";
import { getAllExpenseProject } from "../../redux/rtk/features/expenseProject/expenseProjectSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

function CustomTable({ list, total }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("ACCEPTED");
	const [paymentFilter, setPaymentFilter] = useState("ALL");
	const [columnsToShow, setColumnsToShow] = useState([]);
	const projects = useSelector((state) => state.expenseProject.list);
	const [searchUser, setSearchUser] = useState("");
	const [searchProject, setSearchProject] = useState("");
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);
	const [selectedRows, setSelectedRows] = useState([]);
	const mapProjectName = (projectId) => {
		const project = projects.find(p => p.id === projectId);
		return project ? project.name : projectId;
	};

	const handleDelete = (id) => {
		dispatch(DeleteExpense({ id, values: {} }))
			.unwrap()
			.then(() => {
				dispatch(loadAllExpenseForm());
			})
			.catch((error) => {
				console.error("Delete failed:", error);
			});
	};
	

	const handleCheckboxChange = (e, key) => {
		if (e.target.checked) {
			setSelectedRows((prev) => [...prev, key]);
		} else {
			setSelectedRows((prev) => prev.filter((item) => item !== key));
		}
	};

	const handleMakePayment = () => {
		if (selectedRows.length === 0) {
			return;
		}
		Promise.all(
			selectedRows.map((id) =>
				dispatch(updateExpenseForm({ id, values: { paymentStatus: "PAID" } }))
			)
		)
			.then(() => {
				setSelectedRows([]);
				dispatch(loadAllExpenseForm());
			})
			.catch(() => { });
	};

	const columns = [

		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
			render: (text, record) => (
				<div className="flex items-center">
					{record.paymentStatus !== "PAID" && (
						<Checkbox
							className="mr-2"
							onChange={(e) => handleCheckboxChange(e, record.key)}
						/>
					)}
					<span>{text}</span>
				</div>
			),
		},


		{
			title: "User Name",
			dataIndex: "user",
			key: "user",
			render: (user) => `${user?.firstName || ''} ${user?.lastName || ''}`,
		},
		{
			id: 2,
			title: "Employee ID",
			dataIndex: "user",
			key: "employeeId",
			render: (user) => user?.employeeId || 'N/A',
		},
		{
			id: 2,
			title: "Project",
			dataIndex: "projectName",
			key: "projectName",

		},
		{
			id: 3,
			title: " Expense Title",
			key: "expenseTitle",
			dataIndex: "expenseTitle",
			// render: ({ firstName, lastName }) => firstName + " " + lastName,
		},

		{
			id: 4,
			title: "Expense Amount",
			dataIndex: "expenseAmount",
			key: "expenseAmount",
			// render: (leaveFrom) => dayjs(leaveFrom).format("DD-MM-YYYY"),
		},
		{
			id: 5,
			title: "Expense Date",
			dataIndex: "expenseDate",
			key: "expenseDate",
			render: (expDate) => dayjs(expDate).format("DD-MM-YYYY"),
		},
		// {
		// 	id: 6,
		// 	title: "Leave Duration",
		// 	dataIndex: "leaveDuration",
		// 	key: "leaveDuration",
		// 	render: (leaveDuration) => {
		// 		if (leaveDuration > 1) {
		// 			return <span>{leaveDuration} days</span>;
		// 		} else {
		// 			return <span>{leaveDuration} day</span>;
		// 		}
		// 	},
		// },
		{
			id: 7,
			title: "Approval Status",
			dataIndex: "approvalStatus",
			key: "approvalStatus",
			render: (approvalStatus) => {
				if (approvalStatus === "APPROVED") {
					return <Tag color='green'>{approvalStatus.toUpperCase()}</Tag>;
				} else if (approvalStatus === "REJECTED") {
					return <Tag color='red'>{approvalStatus.toUpperCase()}</Tag>;
				} else if (approvalStatus === "PARTIAL APPROVED") {
					return <Tag color='orange'>{approvalStatus.toUpperCase()}</Tag>
				} else {
					return <Tag color='yellow'>{approvalStatus.toUpperCase()}</Tag>;
				}
			},
		},
		{
        	id: 8,
        	title: "Payment Status",
        	dataIndex: "paymentStatus",
        	key: "paymentStatus",
        	render: (paymentStatus) => {
        		if (paymentStatus === "PAID") {
        			return <Tag color='green'>{paymentStatus.toUpperCase()}</Tag>;
        		} else {
        			return <Tag color='orange'>{(paymentStatus || "UNPAID").toUpperCase()}</Tag>;
        		}
        	},
        },

		{
			id: 7,
			title: "Action",
			key: "action",
			render: ({ id }) => (
				<div className="flex space-x-2">
					<ViewBtn path={`/admin/expense/${id}`} text="View" icon={<BtnViewSvg />} />

					<Popconfirm
						title="Are you sure to delete this expense?"
						onConfirm={() => handleDelete(id)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm>
				</div>
			),
		},
	];
	//make a onChange function
	const onChange = (value) => {
		setStatus(value);
		dispatch(
			loadExpenseFormByStatus({ page: 1, limit: 10, approvalStatus: value })
		);
	};
	const onPaymentFilterChange = (value) => {
        setPaymentFilter(value);
    };

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const onAllClick = () => {
        dispatch(loadAllExpenseForm());
        setStatus("APPROVED");
        setPaymentFilter("ALL");
        setSearchUser("");
        setSearchProject("");
        setFromDate(null);
        setToDate(null);
    };

	// const addKeys = (arr) => arr.map((i) => ({
	// 	 ...i, key: i.id,
	// 	 projectName: mapProjectName(i.projectId)
	// 	 }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1, projectName: mapProjectName(i.projectId) }));
	// const filteredData = addKeys(list).filter((item) => {
	// 	const fullName = `${item.user?.firstName || ""} ${item.user?.lastName || ""}`.toLowerCase();
	// 	const employeeId = `${item.user?.employeeId || ""}`.toLowerCase();
	// 	const searchLower = searchUser.toLowerCase();

	// 	return (
	// 		(fullName.includes(searchLower) || employeeId.includes(searchLower)) &&
	// 		(searchProject ? item.projectName === searchProject : true)
	// 	);
	// });
	const filteredData = addKeys(list).filter((item) => {
        const fullName = `${item.user?.firstName || ""} ${item.user?.lastName || ""}`.toLowerCase();
        const employeeId = `${item.user?.employeeId || ""}`.toLowerCase();
        const searchLower = searchUser.toLowerCase();

        const matchesPaymentFilter = paymentFilter === "ALL" || 
            (paymentFilter === "PAID" && item.paymentStatus === "PAID") ||
            (paymentFilter === "UNPAID" && item.paymentStatus !== "PAID");

        // Date range filtering
        const expenseDate = dayjs(item.expenseDate);
        const matchesDateRange = 
            (!fromDate || expenseDate.isAfter(fromDate) || expenseDate.isSame(fromDate, 'day')) &&
            (!toDate || expenseDate.isBefore(toDate) || expenseDate.isSame(toDate, 'day'));

        return (
            (fullName.includes(searchLower) || employeeId.includes(searchLower)) &&
            (searchProject ? item.projectName === searchProject : true) &&
            matchesPaymentFilter &&
            matchesDateRange
        );
    });
	const csvHeaders = [
		{ label: "S.No", key: "serial" },
		{ label: "User Name", key: "userName" },
		{ label: "Employee ID", key: "employeeId" },
		{ label: "Project", key: "projectName" },
		{ label: "Expense Date", key: "expenseDate" },
		{ label: "Expense Title", key: "expenseTitle" },
		{ label: "Expense Amount", key: "expenseAmount" },
		{ label: "Approved Amount", key: "approvedAmount" },
		{ label: "Approval Status", key: "approvalStatus" },
		{ label: "Payment Status", key: "paymentStatus" },

	];

	const csvData = filteredData.map((item, index) => ({
		serial: index + 1,
		userName: `${item.user?.firstName || ''} ${item.user?.lastName || ''}`.trim() || 'N/A',
		employeeId: item.user?.employeeId || 'N/A',
		projectName: mapProjectName(item.projectId),
		expenseDate: dayjs(item.expenseDate).format("DD-MM-YYYY"),
		expenseTitle: item.expenseTitle || 'N/A',
		expenseAmount: item.expenseAmount || 'N/A',
		approvedAmount: item.approvedAmount || 'N/A',
		approvalStatus: item.approvalStatus || 'N/A',
		paymentStatus: item.paymentStatus || 'N/A',
	}));

	return (
		<div className='ant-card p-4 rounded mt-0'>
			<div className='flex my-2 justify-between'>
				<div className='w-50'>
					<h4 className='text-2xl mb-2'> Expense Forms</h4>
				</div>
				{list && (
					<div className='flex justify-end mr-4'>
						<div className='mt-0.5'>
							<CsvLinkBtn>
								<CSVLink

									data={csvData}
									headers={csvHeaders}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='expense_forms'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>

						<div className='ml-2 mt-0.5'>
							<GreenLinkBtn>
								<button onClick={onAllClick}>
									<BtnAllSvg size={15} title={"ALL"} />
								</button>
							</GreenLinkBtn>
						</div>

						<div>
							<Segmented
								className='text-center rounded'
								size='middle'
								defaultValue={"APPROVED"}
								options={[
									{
										label: (
											<span className='text-orange-500'>
												<i className='bi bi-person-dash-fill text-orange-500'></i> Partial
											</span>
										),
										value: "PARTIAL APPROVED",
									},
									{
										label: (
											<span className='text-green-500'>
												<i className='bi bi-person-lines-fill text-green-500'></i> Approved
											</span>
										),
										value: "APPROVED",
									},
									{
										label: (
											<span className='text-yellow-500'>
												<i className='bi bi-person-dash-fill text-yellow-500'></i> Pending
											</span>
										),
										value: "PENDING",
									},

								]}
								value={status}
								onChange={onChange}
							/>
							<Segmented
                            className='text-center rounded'
                            size='middle'
                            defaultValue={"ALL"}
                            options={[
                                {
                                    label: (
                                        <span className='text-green-500'>
                                            Paid
                                        </span>
                                    ),
                                    value: "PAID",
                                },
                                {
                                    label: (
                                        <span className='text-orange-500'>
                                            Unpaid
                                        </span>
                                    ),
                                    value: "UNPAID",
                                },
                            ]}
                            value={paymentFilter}
                            onChange={onPaymentFilterChange}
                        />
						</div>
					</div>
				)}
			</div>


			{list && (
				<div style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>

					<div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
						<Popconfirm
							title="Do you want to make payment for selected entries?"
							onConfirm={handleMakePayment}
							okText="Yes"
							cancelText="No"
						>
							<Button type="primary" disabled={selectedRows.length === 0}>Make Payment</Button>
						</Popconfirm>
						<Input
							placeholder="Employee ID or Employee Name "
							value={searchUser}
							onChange={(e) => setSearchUser(e.target.value)}
							style={{ width: 250 }}
						/>
						<Select
							placeholder="Search by Project"
							value={searchProject || undefined}
							onChange={(value) => setSearchProject(value)}
							allowClear
							showSearch
							filterOption={(input, option) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							style={{ width: 200 }}
						>
							{(projects || []).map((project) => (
								<Select.Option key={project.id} value={project.name}>
									{project.name}
								</Select.Option>
							))}
						</Select>
						<DatePicker
							placeholder="From Date"
							value={fromDate}
							onChange={(date) => setFromDate(date)}
							format="DD-MM-YYYY"
							style={{ width: 150 }}
							allowClear
						/>
						<DatePicker
							placeholder="To Date"
							value={toDate}
							onChange={(date) => setToDate(date)}
							format="DD-MM-YYYY"
							style={{ width: 150 }}
							allowClear
						/>
					</div>
				</div>
			)}

			<Table
				className='text-center'
				scroll={{ x: true }}
				loading={!list}
				pagination={{
					defaultPageSize: 10,
					pageSize: 10,
					showSizeChanger: false,
					total: filteredData.length,
					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
					onChange: (page, limit) => {
						console.log("page", page, "limit", limit, "value", status);
						dispatch(loadAllExpenseForm({ page, limit: 10, approvalStatus: status }));
					},
				}}
				columns={columnsToShow}
				dataSource={filteredData}
			/>
		</div>
	);
}

const GetAllExpenses = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.expense.list);
	const total = useSelector((state) => state.expense.total);

	useEffect(() => {
		dispatch(loadAllExpenseForm());
		dispatch(countExpenseForm());
		dispatch(getAllExpenseProject());
	}, []);

	// useEffect(() => {
	//   deleteHandler(list, deletedId);
	// }, [deletedId, list]);

	return (
		<UserPrivateComponent permission={"readAll-leaveApplication"}>
			{/* <div className='card card-custom'> */}
			<div>

				<div className='card-body'>
					<CustomTable list={list} total={total} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default GetAllExpenses;
